import { NavigateFunction, useNavigate } from 'react-router';

import { AdvertiserAccount } from '@synapex/shared2/gateway-rest-api';
import { siteMethods } from '@synapex/shared2/entities';

import { isGatewayError } from '@/shared/api/base';
import { useNewWsStoreIs } from '@/true-fsd/data/advertiser-account';
import { useCreate } from '@/true-fsd/data/advertiser-account/react-query';
import { CreateSiteForm, CreateSiteFormProps } from './CreateSiteForm';
import { FormOutputValues, useCreateSiteForm } from './schema';

//values
const makeCreateAccountDto = (
  account: AdvertiserAccount.CreateInputDto,
  { site_url }: FormOutputValues,
): AdvertiserAccount.CreateInputDto => {
  const obj = siteMethods.pickTitleObj(site_url);

  return {
    // eslint-disable-next-line @typescript-eslint/no-misused-spread
    ...account,
    initialWorkspace: obj,
  };
};

//hook
const useCreateAccountWithSite = ({
  onSuccess,
}: CreateAccountWithSiteProps) => {
  const newAccount = useNewWsStoreIs((state) => state.newAccount);
  const navigate = useNavigate();

  const { formState, handleSubmit, control, setError } = useCreateSiteForm();

  const { mutate } = useCreate({
    onSuccess: (created) => onSuccess(navigate, created),
    onError: (error) => {
      // console.log(error)
      setError('site_url', {
        message:
          (isGatewayError(error) ? error.response?.data.message : undefined) ??
          'Не удалось добавить аккаунт и сайт',
      });
    },
  });

  // const formHasErrors =
  //     !formState.isValid || Object.keys(formState.errors).length > 0

  const onSubmit = handleSubmit((values) =>
    mutate(makeCreateAccountDto(newAccount, values)),
  );

  const isSubmitting = formState.isSubmitting;

  return {
    onSubmit,
    isSubmitting,
    control,
    // rootError: formState.errors.root?.message,
  };
};

//component
export type CreateAccountWithSiteProps = {
  onSuccess: (
    nav: NavigateFunction,
    created: Parameters<
      NonNullable<NonNullable<Parameters<typeof useCreate>[0]>['onSuccess']>
    >[0],
  ) => void;
} & Omit<CreateSiteFormProps, 'onSubmit' | 'isSubmitting' | 'control'>;
export const CreateAccountWithSite = (props: CreateAccountWithSiteProps) => {
  const { RenderLayout, RenderBack } = props;
  const { onSubmit, isSubmitting, control } = useCreateAccountWithSite(props);
  return (
    <CreateSiteForm
      {...{ onSubmit, isSubmitting, control, RenderLayout, RenderBack }}
    />
  );
};
